import { pipe, map } from "rxjs"
import { LeadAudit } from "src/app/core/models/lead/lead-audit.model"
import { LeadAuditDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead-audit.dto"
import { userSummaryDtoToUser } from "../user-model-dto/user-dto.mapping"

export const mapLeadAuditDtosToLeadAudits = pipe(
    map((source: LeadAuditDto[]) => source.map(auditDto => leadAuditDtoToLeadAudit(auditDto!)!))!
)

export function leadAuditDtoToLeadAudit(source: LeadAuditDto): LeadAudit | null {
    if (!source) return null
    return {
        id: source.auditId,
        leadId: source.leadId,
        operator: userSummaryDtoToUser(source.operator),
        initialOwner: userSummaryDtoToUser(source.initialOwner),
        finalOwner: userSummaryDtoToUser(source.finalOwner),
        category: source.category,
        comment: source.comment,
        data: source.data,
        updated: new Date(source.updated)
    } as LeadAudit
}